import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, Empty } from "@/components/Badges";
import { DEV_STAGES, fmtDate } from "@/lib/format";

export default function Projects() {
  const { orgId } = useAuth();
  const [rows, setRows] = useState(null);
  const [title, setTitle] = useState("");
  const navigate = useNavigate();
  useEffect(() => {
    if (orgId) api.get(`/orgs/${orgId}/projects`).then(({ data }) => setRows(data));
  }, [orgId]);
  const create = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.post(`/orgs/${orgId}/projects`, { title });
      navigate(`/app/projects/${data.id}`);
    } catch (err) {
      toast.error(errMsg(err));
    }
  };
  return (
    <div className="fade-up">
      <PageHeader title="Projects" sub="Each innovation, product or invention gets its own project. Your business profile is shared across all of them." />
      <form onSubmit={create} className="card mb-6 flex flex-col gap-3 p-5 sm:flex-row" data-testid="new-project-form">
        <input required aria-label="Project title" data-testid="new-project-title-input" placeholder="Project or invention name" className="input" value={title} onChange={(e) => setTitle(e.target.value)} />
        <button data-testid="new-project-submit" className="btn-teal shrink-0">Start project</button>
      </form>
      {rows?.length === 0 && <Empty title="No projects yet">Start with a working title - you can change it later.</Empty>}
      <div className="grid gap-4 md:grid-cols-2">
        {rows?.map((p) => (
          <Link key={p.id} to={`/app/projects/${p.id}`} data-testid={`project-card-${p.id}`} className="card p-5 transition-colors hover:border-[#0D9488]">
            <h2 className="font-display font-semibold text-[#0B192C]">{p.title}</h2>
            <p className="mt-1 text-xs text-slate-500">{DEV_STAGES[p.dev_stage] || "Stage not set"} · updated {fmtDate(p.updated_at)}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
